module.exports = __webpack_public_path__ + "static/media/logo_windowsimulator.6c65c8cd.png";